import React from "react";
import { Menu, IconButton, MenuItem } from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { translate } from "react-i18next";

class ActionMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = { anchorEl: null };
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  handleClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
    });
  }
  handleClose() {
    this.setState({
      anchorEl: null,
    });
  }
  render() {
    const {
      t,
      preview,
      remove,
      rename,
      allowRename,
      allowView,
      allowRemove,
      getFileUrl = null,
    } = this.props;
    const { anchorEl } = this.state;
    return (
      <div>
        <IconButton
          onClick={this.handleClick}
          aria-haspopup="true"
          aria-label="settings"
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          keepMounted
          onClose={this.handleClose}
        >
          {getFileUrl && (
            <MenuItem
              onClick={() => {
                getFileUrl();
              }}
            >
              {t("select_this_image")}
            </MenuItem>
          )}
          {allowView && (
            <MenuItem
              onClick={(event) => {
                preview(event);
                this.handleClose();
              }}
            >
              {t("view_detail")}
            </MenuItem>
          )}
          {allowRename && (
            <MenuItem
              onClick={() => {
                rename();
                this.handleClose();
              }}
            >
              {t("rename")}
            </MenuItem>
          )}
          {allowRemove && (
            <MenuItem
              onClick={() => {
                remove();
                this.handleClose();
              }}
            >
              {t("delete")}
            </MenuItem>
          )}
        </Menu>
      </div>
    );
  }
}
export default translate("translations")(ActionMenu);
